import React, { memo } from "react";
import HomeIcon from "@mui/icons-material/Home";

import "./NewsPaper.css";
import { useHistory } from "react-router-dom";
import { Box, Card, CardContent, Grid } from "@mui/material";
import useCommonQuery from "../../../store/common/useCommonQuery";
import ShareIcon from "@mui/icons-material/Share";

const NewsPaper = () => {
  const history = useHistory();

  const { data: newsPaperList } = useCommonQuery.Get_newsPaper({
    limit: 30,
    offset: 0,
  });

  const handleShare = async () => {
    try {
      await navigator.share({
        url: `https://masterclick.in/news-paper`,
      });
    } catch (error) { }
  };

  return (
    <div className="newspaper-root">
      {/* NEW PREMIUM HEADER - List Mode Crystal Theme */}
      <div className="newspaper-new-header">
        {/* Left: Home Button */}
        <button
          className="newspaper-new-home-btn"
          onClick={() => history.push("/")}
        >
          <HomeIcon style={{ fontSize: "22px" }} />
        </button>

        {/* Center: Malayalam Title */}
        <h1 className="newspaper-new-title">മലയാളം ന്യൂസ്‌പേപ്പർ</h1>

        {/* Right: Share Button */}
        <button
          className="newspaper-new-share-btn"
          onClick={handleShare}
        >
          <ShareIcon style={{ fontSize: "22px" }} />
        </button>
      </div>

      <Grid container spacing={2} sx={{ padding: "0px 12px" }}>
        {newsPaperList &&
          newsPaperList.data.results.map((item, idx) => {
            return (
              <Grid item xs={4} key={idx}>
                <a href={item?.url ? item?.url : ""}>
                  <Card
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "10px",
                      height: "100px",
                      width: "100px",
                    }}
                  >
                    <CardContent
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        style={{ width: "5rem", height: "5rem" }}
                        src={item.image}
                        alt={item.name}
                      />
                    </CardContent>
                  </Card>
                </a>
              </Grid>
            );
          })}
      </Grid>
    </div>
  );
};

export default memo(NewsPaper);
